import React from 'react';
import FsgoItem from './FsgoItem';
import FsgoVideosService from '../FsgoVideosService';

class FsgoItems extends React.Component {
	constructor(props) {
		super(props);
	}

	isSeparatorShown() {
		return FsgoVideosService.isViewAllSeparatorShown(this.props.regionNames, this.props.state === 'live');
	}

	render() {
		const title = this.props.title;
		const state = this.props.state;
		const isLive = state === 'live';
		const videos = this.props.items;
		const allCount = this.props.allCount;
		const regionNames = this.props.regionNames;
		const isSeparatorShown = this.isSeparatorShown();
		const isViewAllShown = !isLive || (videos.length !== allCount);
		let idx = 1;

		return (
			<li className="tune-in-item">
				<div className="tune-in-item-container">
					<div className={state}>
						<div className="title">
							<div className={!isSeparatorShown ? 'text-block' : ''}>
								<span className={isSeparatorShown && regionNames.length > 0 ? 'title-block' : ''}>{title}</span>
								{regionNames.map(n => <span className="region-name">{n}</span>)}
								{isSeparatorShown && isViewAllShown &&
									<span className="view-all-separator"></span>
								}
								{isViewAllShown &&
									<a className={`view-all ${state}`}
									   target="_blank"
									   href="https://www.foxsportsgo.com/">
										{isLive ? `View All (${allCount})` : 'Full Listings'}
									</a>
								}
							</div>
							{isLive &&
								<span className="fsgo-logo"></span>
							}
						</div>
						<div className="content">
							<ul className="videos">
								{videos.map((v) => {
									return (
										<FsgoItem item={v} state={state} isPost={this.props.isPost} idx={idx++}/>
									);
								})}
							</ul>
						</div>
					</div>
				</div>
			</li>
		)
	}
}

export default FsgoItems;



// WEBPACK FOOTER //
// ./react-app-src/fsgo/components/FsgoItems.js